'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils = require('pobble-components/dist/utils');

var CONSTANTS = {
  SENTRY_DSN_KEY: 'https://d1c5e09fda864c328fc685d56c26091b@sentry.io/1473700',
  MIXPANEL_TOKEN: {
    TEST: 'a7a150acefada72fb9d138ce91741660',
    PROD: '5e12fddb59f9ddeaee239702b2832def'
  },
  GTM_CONTAINER_ID: 'GTM-TBS6JPQ',
  USERFLOW_TOKEN: {
    STG: 'ct_tbww3rvzdvdmfkbfgbewfrodwq',
    PROD: 'ct_eb62bwlcjvbrhfcvhgh3j5dwcm'
  }
};
var DOMAIN_PREFIX = utils.getDomainPrefix();
var ENV = utils.getPobbleEnv();
var COOKIE_SETTINGS = ENV === 'local' ? null : {
  domain: '.pobble.com'
};
var URL_PREFIX = DOMAIN_PREFIX ? DOMAIN_PREFIX + '-' : '';
var APP = "https://".concat(URL_PREFIX, "app.pobble.com");
var ADMIN = "https://".concat(URL_PREFIX, "admin.pobble.com");
var MARKETING = "https://".concat(URL_PREFIX, "www.pobble.com");
var MY_POBBLE = "https://my.pobble.com/en-gb";
var HELP = "https://help.pobble.com";
var BLOG = "https://blog.pobble.com";
var URLS = {
  APP: APP,
  AUTH: "".concat(APP, "/auth"),
  ACCOUNT: "".concat(APP, "/account"),
  MEMBERSHIP: "".concat(APP, "/account/membership"),
  ADMIN: ADMIN,
  MARKETING: MARKETING,
  PUPIL_AUTH: "".concat(APP, "/pupil-auth"),
  LESSONS: "".concat(APP, "/lessons"),
  DISCOVER_LESSONS: "".concat(APP, "/lessons/discover"),
  DASHBOARD: "".concat(APP, "/dashboard"),
  ACTIONS: "".concat(APP, "/actions"),
  MODERATION: "".concat(APP, "/moderation"),
  PUPIL_ACTIVITIES: "".concat(APP, "/pupil"),
  MY_POBBLE: MY_POBBLE,
  HELP: HELP,
  BLOG: BLOG
};
exports.CONSTANTS = CONSTANTS;
exports.COOKIE_SETTINGS = COOKIE_SETTINGS;
exports.DOMAIN_PREFIX = DOMAIN_PREFIX;
exports.ENV = ENV;
exports.URLS = URLS;